import request from '@/utils/request'

export default {
    // 主页接口
    index: params => {
        return request({
            url: '/cooperation',
            method: 'GET',
            params
        })
    },
    // 商务合作，意向登记
    bsDetail: params => {
        return request({
            url: '/cooperation/sub',
            method: 'POST',
            params
        })
    },
    aboutlist: params => {
        return request({
            url: '/cooperation/sub',
            method: 'POST',
            params
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/business.js